import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PlanButton, PlanButtonText } from "./mobilePartner/GospelPartnerComponents";

const PlansNameYourOwnPriceModal = ({
                                        planName,
                                        activeCustomPrice,
                                        isOnEditMode,
                                        isModalOpen,
                                        handleModalClose,
                                        checkOutUrl,
                                        defaultPrice,
                                        suggestedPrices,
                                        currencyUnit
                                    }) => {
    let [shouldShowCustomAmountPrompt, setShouldShowCustomAmountPrompt] = React.useState(isOnEditMode);
    let [customAmount, setCustomAmount] = React.useState(activeCustomPrice ?? defaultPrice);
    let [showCustomAmountError, setShowCustomAmountError] = React.useState(false);
    let [showLoading, setShowLoading] = React.useState(false);

    const isCustomAmountValid = (inputAmount = null) => {
        const amountToValidate = inputAmount ?? customAmount;
        const isValid = amountToValidate == null || amountToValidate >= defaultPrice;

        setShowCustomAmountError(!isValid);

        return isValid;
    }

    const handleSubmit = (event) => {
        if (!isCustomAmountValid()) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }

        return true;
    }

    const handleEditSubmit = (event) => {
        if (!isCustomAmountValid()) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }

        setShowLoading(true);

        const formBody = {
            'custom-amount': customAmount,
        }

        fetch('/account/plan/edit-amount', {
            method: 'POST',
            body: JSON.stringify(formBody),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrf_token,
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success) {
                    console.log('success! redirecting...');
                    window.location.href = '/account/plan?amount-updated';
                } else {
                    console.log('failed! redirecting...');
                    window.location.href = '/account/plan?amount-updated-failed';
                }
            });

        return true;
    }

    const suggestedPricesButtons = suggestedPrices.map((priceDetail, index) => (
        <Button
            key={index}
            variant={'outline-primary'}
            active={customAmount === priceDetail.amount}
            onClick={() => setCustomAmount(priceDetail.amount)}
            className={`mt-0 mb-0 text-center has-float-label ${priceDetail.label && `floating-label-parent`}`}
            style={{
                color: customAmount === priceDetail.amount ? '' : '#141D25',
                fontSize: '1.25rem',
            }}
        >
            <label>{priceDetail.label}</label>
            {currencyUnit}{priceDetail.amount}
        </Button>
    ));


    return (
        <Modal className={'plans_name_your_own_price_modal'} show={isModalOpen} onHide={handleModalClose} centered
               fullscreen={'sm-down'}>
            <Modal.Header className={'px-4 pt-4 pb-0'} closeButton style={{borderBottom: 'none'}}>
                <Container>
                    <Row>
                        {isOnEditMode
                            ? <Modal.Title>
                                {activeCustomPrice
                                    ? <>Edit your custom amount for your GP {planName} Plan</>
                                    : <>Set custom amount</>}</Modal.Title>
                            :
                            <Modal.Title>Thank you for selecting the Gospel Partner {planName} plan! Would you consider
                                setting a
                                custom amount for your subscription?</Modal.Title>
                        }
                    </Row>
                    <Row>
                        {!isOnEditMode && <>
                            <p className={'mt-3'}>
                                By setting a higher amount for your Gospel Partner {planName} plan, you will receive the
                                full
                                benefits of
                                the plan. On top of that, you will be <b>supporting our content creation work</b> that
                                goes
                                behind
                                getting the Gospel out in a greater way, and allow us to make more resources
                                available for
                                free for generations to come.
                            </p>
                            <p>As GospelPartner.com is a publishing house
                                with a focus to advance the Gospel through resources, <b>we do not accept</b> tithes,
                                offerings
                                and donations. There is also no tax deductibility offered on subscription plans.</p>
                        </>}
                    </Row>
                    {isOnEditMode &&
                        <>
                            <Row>
                                <Modal.Title><p className={'pt-3'}>Existing
                                    amount: {currencyUnit}{activeCustomPrice ?? defaultPrice}/Month</p>
                                </Modal.Title>
                            </Row>
                            <Row>
                                <Modal.Title className={'pt-1'}>
                                    <p>{isOnEditMode ? `Set a new amount:` : `New amount:`}</p></Modal.Title>
                            </Row>
                        </>}
                </Container>
            </Modal.Header>
            <Modal.Body className={'px-4 py-0'}>
                <div className="btn-group-vertical btn-group checkout__shipping">
                    {!isOnEditMode &&
                        <><label
                            onClick={() => {
                                setShouldShowCustomAmountPrompt(false);
                                setCustomAmount(defaultPrice);
                            }}
                            className={`btn checkout__shipping__btn ${shouldShowCustomAmountPrompt ? '' : 'active plans_name_your_own_price_modal__option--active'}`}
                        >
                            Stay with {currencyUnit}{defaultPrice}/Month
                        </label>

                            <label
                                id={'btn-setACustomAmount'}
                                onClick={() => {
                                    setShouldShowCustomAmountPrompt(true)
                                    setCustomAmount(null)

                                }}
                                className={`btn checkout__shipping__btn ${shouldShowCustomAmountPrompt ? 'active plans_name_your_own_price_modal__option--active' : ''}`}
                            >
                                Set a custom amount
                            </label></>
                    }

                    {(shouldShowCustomAmountPrompt) && (
                        <div className={'w-100 my-1'}>
                            <div className={'mt-2'}>
                                <Form.Label htmlFor="inlineFormInputGroup" srOnly>
                                    {currencyUnit} Enter Custom Amount
                                </Form.Label>
                                <InputGroup hasValidation className={'my-2'}>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text style={{
                                            background: 'none'
                                        }}>{currencyUnit}</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControl
                                        autoFocus
                                        id="inlineFormInputGroup"
                                        name="custom_amount"
                                        type={'number'}
                                        placeholder="Enter Custom Amount"
                                        // value={customAmount}
                                        step={'.01'}
                                        min={defaultPrice}
                                        onChange={e => {
                                            const inputAmount = e.target.value ?? null
                                            setCustomAmount(inputAmount)
                                            isCustomAmountValid(inputAmount)
                                        }}
                                        className={`p-4 ${showCustomAmountError ? 'is-invalid' : ''}`}
                                        style={{
                                            background: 'none',
                                            borderRadius: '0',
                                        }}
                                    />
                                    <InputGroup.Append>
                                        <InputGroup.Text style={{
                                            background: 'none',
                                            borderRadius: '0 0.25rem 0.25rem 0',
                                        }}>/Month</InputGroup.Text>
                                    </InputGroup.Append>
                                    <div
                                        className={`valid-feedback d-block ${showCustomAmountError ? 'text-danger' : 'text-body'}`}

                                    >
                                        The lowest amount for this tier is {currencyUnit}{defaultPrice}/Month
                                    </div>
                                </InputGroup>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className={'px-4'} style={{borderTop: 'none', paddingTop: 0}}>
                <Container>
                    <Row className={'justify-content-center'}>
                        {customAmount && (customAmount != defaultPrice) && (
                            <small className={'text-center'}>
                                You have selected: {currencyUnit}{customAmount}/Month
                                <br/>
                                {isOnEditMode && <>Changes will be in effect from your next billing date</>}
                            </small>)}


                        {isOnEditMode
                            ? <>{showLoading
                                ? <PlanButton className={'py-2'} href={`#`}>
                                    <PlanButtonText className='pt-1 pb-1'>
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </PlanButtonText>
                                </PlanButton>
                                : <PlanButton id={'btn-setACustomAmountSubmit'} className={'py-2 showLoader'} href={`#`}
                                              onClick={handleEditSubmit}>
                                    <PlanButtonText className={'showLoader'}>
                                        <h6 className={'m-0 showLoader'}>Confirm</h6>
                                    </PlanButtonText>
                                </PlanButton>
                            }
                            </>
                            : <PlanButton id={'btn-setACustomAmountSubmit'} className={'py-2'}
                                          href={checkOutUrl + customAmount} onClick={handleSubmit}>
                                <PlanButtonText>
                                    <h6 className={'m-0'}>PROCEED TO CHECKOUT</h6>
                                </PlanButtonText>
                            </PlanButton>
                        }
                    </Row>

                    <Row>
                        <p className={'text-center w-100'} style={{lineHeight: '1rem'}}>
                            <small>
                                {shouldShowCustomAmountPrompt && <>You can edit your custom amount or cancel at any
                                    time.</>}
                            </small>
                        </p>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

export default PlansNameYourOwnPriceModal;